
import React from 'react';
import { Routes } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import PageLoadingSpinner from '@/components/common/PageLoadingSpinner';
import { LazyRoute } from '@/components/common/LazyRoute';
import { getPublicRoutes } from './routes/publicRoutes';
import { getCoreProtectedRoutes } from './routes/protectedRoutes';
import { getProfileRoutes } from './routes/profileRoutes';
import { getRentalRoutes } from './routes/rentalRoutes';
import { getAdminRoutes } from './routes/adminRoutes';
import { getErrorRoutes } from './routes/errorRoutes';

const AppRoutes: React.FC = () => {
  const { isLoading } = useAuth();

  // Show loading state while auth is being determined
  if (isLoading) {
    return <PageLoadingSpinner />;
  }

  return (
    <Routes>
      {/* Public routes */}
      {getPublicRoutes()}
      
      {/* Core protected routes */}
      {getCoreProtectedRoutes()}
      
      {/* Profile routes */}
      {getProfileRoutes()}
      
      {/* Rental management routes */}
      {getRentalRoutes()}
      
      {/* Admin routes */}
      {getAdminRoutes()}
      
      {/* Error routes */}
      {getErrorRoutes()}
    </Routes>
  );
};

export default AppRoutes;
